import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import ModalAddRatePlan from "screens/ModalAddRatePlan";
import Slider from "./Slider";
import { useQuery } from "@apollo/client";
import { GET_ALL_RATE_PLANS } from "graphql/service";
import { Content, RatePlanTableContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import { RemoveIcon, EditIcon } from "assets/icons";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";

const RatePlan = () => {
  const [ratePlans, setRatePlans] = useState([]);

  const { data: ratePlanData, error } = useQuery(GET_ALL_RATE_PLANS);

  useEffect(() => {
    if (ratePlanData) {
      setRatePlans(ratePlanData.ratePlans);
    }
  }, [ratePlanData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  const ratePlanArray = ratePlans.map((ratePlan, index) => {
    return (
      <tr key={index}>
        <td className="ratePlanCode">{ratePlan.title}</td>
        <td className="discount">
          {ratePlan.rateChangeType === "decrease_by_percent"
            ? ratePlan.rateChangeValue + "%"
            : "$" + ratePlan.rateChangeValue}
        </td>
        <td className="roomType">
          {ratePlan.roomTypes.length === 8
            ? "All"
            : ratePlan.roomTypes.reduce((acc, roomType, index) => {
                if (index === ratePlan.roomTypes.length - 1)
                  return acc + roomType.roomType.name;
                return acc + roomType.roomType.name + ", ";
              }, "")}
        </td>
        <td className="earliestCheckIn">{moment(ratePlan.earliestCheckIn).tz(TIME_ZONE).format('MM/DD/YYYY')}</td>
        <td className="latestCheckOut">{moment(ratePlan.latestCheckOut).tz(TIME_ZONE).format('MM/DD/YYYY')}</td>
        <td className="fromTO">
          <div>{moment(ratePlan.from).tz(TIME_ZONE).format('MM/DD/YYYY')}</div>
          <div>{moment(ratePlan.to).tz(TIME_ZONE).format('MM/DD/YYYY')}</div>
        </td>
        <td className="onOff">
          <div className="slider">
            <Slider
              ratePlanId={ratePlan.ratePlanId}
              checked={ratePlan.isActive}
              setRatePlans={setRatePlans}
            />
          </div>
        </td>
        <td className="action">
          <div className="actions">
            <span className="edit">
              <EditIcon /> Edit
            </span>
            <span className="delete">
              <RemoveIcon /> Remove
            </span>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">CURRENT RATE PLAN</div>
        <div className="buttonContainer">
          <ModalAddRatePlan
            buttonStyle={`
              width: 114px;
            `}
            setRatePlans={setRatePlans}
          />
        </div>
      </CardHeader>
      <Content>
        {ratePlanArray.length === 0 ? (
          <div className="noRatePlan">
            There are no coupon code available. Please use 'Add Coupon Code' to
            create one.
          </div>
        ) : (
          <>
            <div className="ratePlanDescription">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. culpa qui officia
              deserunt mollierunt mollie.”
            </div>
            <RatePlanTableContainer>
              <thead>
                <tr>
                  <th className="ratePlanCode">RATE PLAN CODE</th>
                  <th className="discount">DISCOUNT</th>
                  <th className="roomType">ROOM TYPE</th>
                  <th className="earliestCheckIn">EARLIEST CHECK IN</th>
                  <th className="latestCheckOut">LATEST CHECK OUT</th>
                  <th className="fromTO">FROM / TO</th>
                  <th className="onOff">ON/OFF</th>
                  <th className="action">ACTION</th>
                </tr>
              </thead>
              <tbody>{ratePlanArray}</tbody>
            </RatePlanTableContainer>
          </>
        )}
      </Content>
    </Card>
  );
};

export default RatePlan;
